import React from 'react';
import { updateBodyClass } from 'src/helpers';
import HomeContainer from 'src/ui/features/Home/containers/HomeContainer';
import { BODY_CLASSES } from 'src/constants/constants.js';

class HomeRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.HOME);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.HOME);
  }

  render() {
    return <HomeContainer />;
  }
}

export default HomeRoot;
